var map = {
	"./Bandage.png": 6434,
	"./BangSnap.png": 4254,
	"./BeadLizard.png": 1720,
	"./BeesmasTop.png": 4729,
	"./BeesmasTreeHat.png": 1843,
	"./Beret.png": 626,
	"./BottleCap.png": 1722,
	"./BubbleLight.png": 2729,
	"./CamoBandana.png": 7952,
	"./CharmBracelet.png": 9095,
	"./ElectricCandle.png": 2031,
	"./ElfCap.png": 6526,
	"./FestiveWreath.png": 7006,
	"./Icicles.png": 3973,
	"./Kazoo.png": 2536,
	"./LumpOfCoal.png": 4780,
	"./PaperAngel.png": 7792,
	"./Paperclip.png": 5900,
	"./PeppermintAntennas.png": 5778,
	"./Pinecone.png": 6245,
	"./PinkShades.png": 7794,
	"./Poinsettia.png": 2323,
	"./ReindeerAntlers.png": 7940,
	"./Remove.png": 1804,
	"./SingleMitten.png": 8285,
	"./SmileySticker.png": 9450,
	"./SnowTiara.png": 5344,
	"./Snowglobe.png": 3345,
	"./Sweatband.png": 5796,
	"./Thimble.png": 1225,
	"./Thumbtack.png": 898,
	"./ToyDrum.png": 4469,
	"./ToyHorn.png": 2079,
	"./WarmScarf.png": 8772,
	"./Whistle.png": 7815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8465;